import { axiosInstance } from '@/modules/shared/lib/axios';
import { ViolationConfigurationModel } from './types';

type Props = {
  companyId: string
}

export function getViolationsConfiguration({ companyId }: Props) {
  return axiosInstance.get<ViolationConfigurationModel>(`/api/${companyId}/configuration/violations`);
}
